export default __webpack_public_path__ + "static/media/google-login.956ab60a.svg";